import { api } from 'api'
import { path } from 'ramda'
import { Roster, User } from 'typings/common_defs'

export type CompanyWorker = Pick<
  User,
  | 'id'
  | 'name'
  | 'profilePicUrl'
  | 'numShiftsForCompany'
  | 'rating'
  | 'shadowBlocked'
  | 'status'
  | 'statusForCompany'
  | 'workForCompany'
> & {
  rosters?: Array<Pick<Roster, 'id' | 'name'>>
}

export enum StatusEnum {
  Active = 'active',
  Blocked = 'blocked',
  Suspended = 'suspended',
}

export interface PaginatedCompanyWorkers {
  cursor: string
  items: CompanyWorker[]
}

interface CompanyWorkersQuery {
  cursor?: string
  search?: string
  includeRosters?: boolean
}

export async function getCompanyWorkers(params: CompanyWorkersQuery) {
  const { cursor, search, includeRosters = false } = params

  if (includeRosters) {
    const data = await api.post(
      '/company/graphql_dispatch/workers_query_with_rosters_a4f1de11',
      {
        cursor,
        search,
      }
    )

    return path(
      ['data', 'data', 'company', 'workers2'],
      data
    ) as PaginatedCompanyWorkers
  }

  const data = await api.post(
    '/company/graphql_dispatch/workers_query_ad2042ef',
    {
      cursor,
      search,
    }
  )

  return path(
    ['data', 'data', 'company', 'workers2'],
    data
  ) as PaginatedCompanyWorkers
}

export interface InviteWorkerRequest {
  name: string
  email: string | null
  phoneNumber: string | null
}

export async function inviteWorker(
  companyId: number,
  data: InviteWorkerRequest
) {
  await api.post(`/company/${companyId}/worker_invite`, {
    name: data.name,
    email: data.email,
    phone_number: data.phoneNumber,
  })
}

export interface WorkerInvite {
  id: number
  name: string
  email: string | null
  createdAt: string
}

export async function getPendingWorkerInvites() {
  const data = await api.post(
    '/company/graphql_dispatch/pending_worker_invites_44bdeabf',
    {}
  )

  return path(
    ['data', 'data', 'company', 'pendingWorkerInvites'],
    data
  ) as WorkerInvite[]
}
